import { Component, OnInit, ChangeDetectorRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { Location } from '@angular/common';

import { ObservationsAndRecommandationsPluginService } from './observationsandrecommandations-plugin.service';
import { BaseModalPageComponent } from '../../base-modal.component';
import { ModalComponent } from '../../modal/modal.component';
import { ConfirmComponent } from '../../modal/confirm.component';
import { ObservationMenuComponent } from '../../menus/index';
import { EditObservationComponent } from './edit-observation.component';
import { AddObservationComponent } from './add-observation.component';

import * as _ from 'lodash';

@Component({
    selector: 'observationsandrecommandations-edit',
    templateUrl: './observationsandrecommandations-edit.component.html',
    standalone: false
})
export class ObservationsAndRecommandationsPluginPageComponent extends BaseModalPageComponent implements OnInit {
  inspectionId: string;
  pointId: string;
  pluginId: string;
  public plugin: any;
  public observationsAndRecommandations: any;
  public newObservationAndRecommandation: any;
  public responsibles: any;
  public priorities: any;
  public machines: any;
  public currentIndex: number;
  public processing = false;
  @ViewChild('menuModal', { static: true })
  menuModal: ModalComponent;
  @ViewChild('deleteConfirm', { static: true })
  deleteConfirm: ConfirmComponent;
  @ViewChild('editObservation', { static: true })
  editObservationModal: EditObservationComponent;
  @ViewChild('addObservation', { static: true })
  addObservationModal: AddObservationComponent;

  public menuComponent = ObservationMenuComponent;
  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    location: Location,
    private service: ObservationsAndRecommandationsPluginService,
    private cdRef: ChangeDetectorRef
  ) {
    super(location);
  }

  initRoute(): void {
    this.activatedRoute.params.subscribe((params: Params) => {
      const id = params['inspectionId'];
      if (id == null) this.goToBack();

      this.inspectionId = id;

      const pointId = params['pointId'];
      if (pointId == null) this.goToBack();

      this.pointId = pointId;

      const pluginId = params['pluginId'];
      if (pluginId == null) this.goToBack();

      this.pluginId = pluginId;

      this.initData();
    });
  }

  saveObservation(obs: any) {
    this.observationsAndRecommandations[this.currentIndex] = obs;
  }

  save() {
    this.processing = true;
    let messageInfo = {};
    if (!this.plugin.inspection.isTemplate()) {
      messageInfo = {
        pointName: this.plugin.point.name,
        folderName: this.plugin.point.folder ? this.plugin.point.folder.name : '',
        sectionName: this.plugin.point.section.name,
        templateName: this.plugin.inspection.tplName
      };
    }
    this.service
      .updateObservationsAndRecommandations(
        this.inspectionId,
        this.pointId,
        this.pluginId,
        this.observationsAndRecommandations,
        messageInfo
      )
      .subscribe((el) => {
        this.processing = false;
        this.goToBack();
      });
  }

  cancel() {
    this.goToBack();
  }

  ngOnInit() {
    this.initRoute();
  }

  openEditObservation(i: number) {
    const observation = _.clone(this.observationsAndRecommandations[i]);
    this.currentIndex = i;
    this.editObservationModal.open(observation);
  }

  initData() {
    this.service.getPlugin(this.inspectionId, this.pluginId).subscribe((data) => {
      this.plugin = data;
      this.observationsAndRecommandations =
        this.plugin.config.ObservationsAndRecommandations != null
          ? this.plugin.config.ObservationsAndRecommandations.map((x: any) => Object.assign({}, x))
          : [];
      this.cdRef.detectChanges();
      let machines =
        data.inspection.data != null && data.inspection.data.machine != null ? data.inspection.data.machine : null;
      if (machines) {
        if (!(machines instanceof Array)) {
          machines = [this.machines];
        }
        this.machines = machines;
      }
    });

    this.responsibles = this.service.getResponsibles();
    this.priorities = this.service.getPriorities();
    this.initNewObservationAndRecommandation();
  }

  saveAddObservation() {
    if (this.observationsAndRecommandations == null) this.observationsAndRecommandations = [];
    this.observationsAndRecommandations.push({
      Selected: !this.plugin.inspection.isTemplate(),
      Observation: this.newObservationAndRecommandation.Observation,
      Recommandation: this.newObservationAndRecommandation.Recommandation,
      ToInformAdmin: this.newObservationAndRecommandation.ToInformAdmin,
      CanAddToTemplate: this.newObservationAndRecommandation.CanAddToTemplate,
      Impact: {},
      Responsible: -1,
      Priority: 0
    });
    this.initNewObservationAndRecommandation();
    if (!this.plugin.inspection.isTemplate()) {
      this.openEditObservation(this.observationsAndRecommandations.length - 1);
    }
  }

  public initNewObservationAndRecommandation() {
    this.newObservationAndRecommandation = {
      Observation: '',
      Recommandation: '',
      CanAddToTemplate: !this.plugin.inspection.isTemplate()
    };
  }

  remove(index: number) {
    this.observationsAndRecommandations.splice(index, 1);
  }

  removeObservation() {
    this.remove(this.currentIndex);
  }

  public selectMenu(item: any) {
    switch (item) {
      case 1:
        this.openDeleteConfirm();
        break;
      case 2:
        this.openAddObservation();
        break;
      case 10:
        this.gotoEditJsonPage();
        break;
      case 11:
        this.gotoEditPage();
        break;
      default:
    }
  }

  gotoEditJsonPage() {
    return this.router.navigate([
      this.inspectionsRoute,
      this.inspectionId,
      'points',
      this.pointId,
      'plugins',
      this.pluginId,
      'editjson'
    ]);
  }

  gotoEditPage() {
    return this.router.navigate([
      this.inspectionsRoute,
      this.inspectionId,
      'points',
      this.pointId,
      'plugins',
      this.pluginId,
      'edit'
    ]);
  }

  openDeleteConfirm() {
    this.deleteConfirm.open();
  }

  openAddObservation() {
    this.initNewObservationAndRecommandation();
    this.addObservationModal.open(this.newObservationAndRecommandation);
  }

  deletePlugin() {
    this.service.deletePlugin(this.inspectionId, this.pointId, this.pluginId).subscribe((success: boolean) => {
      if (success) {
        this.goToBack();
      }
    });
  }
}
